import PermissionIssue from "../../components/permissionIssue";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/store";
import { LinearProgress } from "@mui/material";
import Dashboard from "../../components/dashboard";

const NewDashboardPage = () => {
  const [isAllow, setIsAllow] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const { userData } = useAppSelector((state) => state.authReducer);

  useEffect(() => {
    if (userData) {
      setIsAllow(
        JSON.parse(
          userData.permission !== null ? userData.permission : "[]"
        ).includes("13")
      );
      setIsReady(true);
    }
  }, [userData]);

  return isReady ? (
    <>
      {isAllow || userData.group === "admin" ? (
        <Dashboard />
      ) : (
        <PermissionIssue />
      )}
    </>
  ) : (
    <LinearProgress color="secondary" />
  );
};

export default NewDashboardPage;
